export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M11 7h2v4h4v2h-4v4h-2v-4H7v-2h4zM4 20h16V4H4zM20 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z\"/>"
};